<div class="summary-container" [class.has-error]="error">
  <div class="summary-main-icon-container">
    <img
      [src]="getCurrencyIconPath(displayDetails.currency)"
      (error)="useFallbackIcon($event)"
      alt="Currency Icon"
      />
  </div>

  <div class="summary-title" [ngClass]="{ 'error-title': error !== null }">{{ title }}</div>

  @if (error) {
    <div class="error-banner">
      <span>{{ error }}</span>
    </div>
  }

  @if (!error) {
    <div class="summary-line summary-line-top"></div>
  }

  <div class="summary-details-grid">
    <div class="summary-detail-item">
      <div class="summary-detail-label">Currency</div>
      <div class="summary-detail-value">
        <img
          class="summary-currency-icon"
          [src]="getCurrencyIconPath(displayDetails.currency)"
          (error)="useFallbackIcon($event)"
          alt="Currency Icon"
          />
        {{ displayDetails.currency }}
      </div>
    </div>
    @if (displayDetails.network) {
      <div class="summary-detail-item">
        <div class="summary-detail-label">Blockchain</div>
        <div class="summary-detail-value">{{ displayDetails.network }}</div>
      </div>
    }
    @if (isSettlementApp) {
      <div class="summary-detail-item">
        <div class="summary-detail-label">Source Wallet Name</div>
        <div class="summary-detail-value black">
          {{ displayDetails.sourceWalletName }}
        </div>
      </div>
      <div class="summary-detail-item">
        <div class="summary-detail-label">Source Wallet</div>
        <div class="summary-detail-value black">
          <span class="olv-address" [matTooltip]="displayDetails.sourceWallet" matTooltipPosition="above">
            {{ getShortAddress(displayDetails.sourceWallet) }}
          </span>
        </div>
      </div>
    }
    <div class="summary-detail-item">
      <div class="summary-detail-label">Amount (Currency)</div>
      <div class="summary-detail-value">{{ displayDetails.currency }} {{ displayDetails.amount | formatCoinCurrency : displayDetails.currencyPrecision }}</div>
    </div>
    <div class="summary-detail-item">
      <div class="summary-detail-label">Value ({{ displayDetails.baseCurrencySymbol }})</div>
      <div class="summary-detail-value">
        {{ displayDetails.convertedAmount | formatCoinCurrency : displayDetails.baseCurrencyPrecision : displayDetails.baseCurrencySymbol }}
      </div>
    </div>
    <div class="summary-detail-item">
      <div class="summary-detail-label">Exchange Rate</div>
      <div class="summary-detail-value">
        {{ displayDetails.exchangeRate | formatCoinCurrency : displayDetails.baseCurrencyPrecision : displayDetails.baseCurrencySymbol }}
      </div>
    </div>
    <div class="summary-detail-item">
      <div class="summary-detail-label">Target Wallet Name</div>
      <div class="summary-detail-value">
        {{ displayDetails.targetWalletName }}
      </div>
    </div>
    <div class="summary-detail-item">
      <div class="summary-detail-label">Target Wallet</div>
      <div class="summary-detail-value">
        <span class="olv-address" [matTooltip]="displayDetails.targetWallet" matTooltipPosition="above">
          {{ getShortAddress(displayDetails.targetWallet) }}
        </span>
      </div>
    </div>
  </div>

  <div class="summary-line summary-line-bottom"></div>

  <div class="summary-button-container">
    @if (closeClicked.observed) {
      <app-button
        buttonVariant="summary-secondary"
        buttonType="button"
        (buttonClick)="onCloseClick()"
        >
        Close
      </app-button>
    }
    <app-button
      buttonVariant="summary-primary"
      buttonType="button"
      (buttonClick)="onActionClick()"
      >
      {{ actionButtonText }}
    </app-button>
  </div>
</div>
